export default __webpack_public_path__ + "static/media/back-arrow.ad38f1ed.svg";